module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "information-dialog"
  }, [_c('v-card-title', [_c('div', {
    staticClass: "half-width"
  }, [_c('h2', [_vm._v(_vm._s(_vm.device.name))])]), _vm._v(" "), _c('div', {
    staticClass: "half-width to-right"
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:dialog', false)
      }
    }
  }, [_vm._v("close")])], 1)]), _vm._v(" "), _c('v-card-text', {
    staticClass: "without-margin"
  }, [_c('v-container', [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', [_vm._v("Ubicacion")])]), _vm._v(" "), _c('div', {
    staticClass: "half-width to-right"
  }, [_c('v-icon', {
    staticClass: "inline to-right",
    attrs: {
      "medium": ""
    },
    on: {
      "click": _vm.viewLocation
    }
  }, [_vm._v("location_on")]), _vm._v(" "), _c('v-icon', {
    staticClass: "inline to-right",
    attrs: {
      "medium": ""
    },
    on: {
      "click": _vm.shareLocation
    }
  }, [_vm._v("share")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', [_vm._v("Organizacion")])]), _vm._v(" "), (_vm.device.Organization) ? _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v(_vm._s(_vm.device.Organization.name))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', {
    staticClass: "inline"
  }, [_vm._v("Lote")])]), _vm._v(" "), (_vm.device.Crops[0]) ? _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v(_vm._s(_vm.device.Crops[0].name))])])]) : _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v("Sin lote")])])])]), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', {
    staticClass: "inline"
  }, [_vm._v("Area")])]), _vm._v(" "), _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v(_vm._s(_vm.device.area) + " has.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', {
    staticClass: "inline"
  }, [_vm._v("Largo del equipo")])]), _vm._v(" "), _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v(_vm._s(_vm.device.length) + " m.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "half-width"
  }, [_c('h3', {
    staticClass: "inline"
  }, [_vm._v("Caudal")])]), _vm._v(" "), _c('div', {
    staticClass: "half-width to-right"
  }, [_c('strong', [_c('p', {
    staticClass: "inline to-right"
  }, [_vm._v(_vm._s(_vm.device.pumpFlow) + " m"), _c('sup', [_vm._v("3")]), _vm._v("/h")])])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76229e0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Item/DeviceInformation.vue
// module id = 630
// module chunks = 1 6